module.exports = __webpack_public_path__ + "media/images/icon/student-role-b73ff764604d013b39191b10628c4743.svg";